import {useForm} from 'react-hook-form';
import {useId} from 'react';
import {Form} from '@common/ui/forms/form';
import {AccountSettingsPanel} from '@common/auth/ui/account-settings/account-settings-panel';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {ChangeEmailPayload, useChangeEmail} from './use-change-email';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
import {User} from '@common/auth/user';

interface Props {
  user: User;
}

export function ChangeEmailPanel({user}: Props) {
  const form = useForm<ChangeEmailPayload>();
  const formId = useId();
  const changeEmail = useChangeEmail(form);
  return (
    <AccountSettingsPanel
      id={AccountSettingsId.Email}
      title={<Trans message="Change email address" />}
      actions={
        <Button
          type="submit"
          form={formId}
          variant="flat"
          color="primary"
          disabled={!form.formState.isValid || changeEmail.isPending}
        >
          <Trans
            message={changeEmail.isPending ? 'Sending...' : 'Change email'}
          />
        </Button>
      }
    >
      <div className="mb-24 text-sm text-muted">
        <Trans
          message="Your current email address is :email"
          values={{email: user.email}}
        />
      </div>
      <Form
        form={form}
        id={formId}
        onSubmit={newValues => {
          changeEmail.mutate(newValues, {
            onSuccess: () => {
              form.reset();
            },
          });
        }}
      >
        <FormTextField
          className="mb-24"
          name="password"
          label={<Trans message="Current password" />}
          type="password"
          autoComplete="current-password"
          required
        />
        <FormTextField
          name="email"
          label={<Trans message="New email address" />}
          type="email"
          autoComplete="email"
          required
        />
      </Form>
    </AccountSettingsPanel>
  );
}
